'use client'

import { useEffect } from 'react'

import { useQuickStartLanguageContext } from '@/shared/components/QuickStartLayoutShell/context/quickStartLanguageContext'

interface QuickStartLanguageSyncProps {
  language: string
}

/**
 * Syncs the language resolved from the current URL into the global
 * QuickStartLanguageContext (and localStorage). This ensures the sidebar
 * menu and prev/next links always reflect the language the user arrived
 * at via direct URL or browser navigation.
 */
export function QuickStartLanguageSync({ language }: QuickStartLanguageSyncProps) {
  const { setSelectedLanguage } = useQuickStartLanguageContext()

  useEffect(() => {
    if (language && language !== 'default') {
      setSelectedLanguage(language)
    }
  }, [language, setSelectedLanguage])

  return null
}
